export default "__VITE_ASSET__o4q82cBV__"